import Vue from "vue";
import debounce from "./src/debounce";
import positiveInteger from "./src/positiveInteger";
import positivePoint2 from "./src/positivePoint2";
import regexFilter from "./src/regexFilter";

// 防重复点击
Vue.directive("debounce", debounce);
// 只能输入正整数(包括0)
Vue.directive("positiveInteger", positiveInteger);
// 只能输入正整数(包括0)或小数，小数只保留2位
Vue.directive("positivePoint2", positivePoint2);
// 只能输入通过正则条件的字符
Vue.directive("regexFilter", regexFilter);
